import { UI_THEME } from '@bale-bot/config';

/**
 * Visualization tokens.
 *
 * Single-hue by design: every chart in the panel compares magnitude, which is a
 * sequential job — one hue, more-is-longer. No categorical palette is in play,
 * so nothing here can drift into a rainbow.
 *
 * `series` is the panel's brand blue and was validated against the white card
 * surface (lightness band, chroma floor and >= 3:1 contrast all pass). Chrome
 * greys are one step off the surface so grid and axis stay recessive.
 *
 * The panel ships light-mode only. A dark mode needs its own steps chosen for
 * the dark surface — never an automatic flip of these values.
 */
export const VIZ = {
  series: UI_THEME.primaryColor,
  /** Lighter step of the same blue ramp — meter tracks and de-emphasis. */
  seriesTrack: '#cde2fb',
  surface: '#ffffff',
  grid: '#e1e0d9',
  baseline: '#c3c2b7',
  /** Bars: thin marks, capped so the slot keeps some air. */
  barThickness: 10,
  columnMaxWidth: 24,
  /** 4px rounded data-end, square at the baseline. */
  radius: 4,
  /** Surface gap between touching marks. */
  gap: 2,
} as const;

/** 1,284 / 12.9K / 3.4M — compact figures for stat tiles. */
export function formatCompact(value: number): string {
  if (Math.abs(value) >= 1_000_000) return `${(value / 1_000_000).toFixed(1)}M`;
  if (Math.abs(value) >= 10_000) return `${(value / 1_000).toFixed(1)}K`;
  return value.toLocaleString('en-US');
}

/** `2026-08-12` -> `Aug 12` */
export function formatDayLabel(isoDate: string): string {
  const date = new Date(`${isoDate}T00:00:00Z`);
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', timeZone: 'UTC' });
}